// Sets the macOS dock badge (unread count) on the Tauri desktop app. No-op in
// the browser. Passing 0 clears the badge.
//
// Main window only: the dock badge is app-wide, and a messaging pop-out counting
// from its own (possibly different) state would fight the main window over it.
import { isSecondaryAppWindow } from './desktopWindow';

export async function setDockBadge(count: number): Promise<void> {
  if (typeof window === 'undefined' || !('__TAURI__' in window)) return;
  if (isSecondaryAppWindow()) return;
  try {
    const { getCurrentWindow } = await import('@tauri-apps/api/window');
    await getCurrentWindow().setBadgeCount(count > 0 ? count : undefined);
  } catch (error) {
    console.error('setDockBadge failed:', error);
  }
}
